<template>
  <v-app id="portal">
    <v-content class="px-3">
      <titulo-responsivo
        :titulo="locale[local].screen.comprasVarejo.tituloLabel"
      />
      <v-divider />

      <template>
        <v-row justify="space-around">
          <v-col cols="12" sm="8" md="6">
            <v-skeleton-loader
              :loading="loadingPeriodos"
              transition="scale-transition"
              height="80"
              :types="{ skeleton: 'list-item' }"
              type="skeleton"
            >
              <v-slide-group show-arrows>
                <v-chip-group
                  v-model="filterPeriod"
                  active-class="white--text primary"
                >
                  <v-chip
                    v-for="option in datas"
                    :key="option.descricao"
                    @click="buscaVarejo(option)"
                  >
                    {{ option.descricao }}
                  </v-chip>
                </v-chip-group>
              </v-slide-group>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </template>

      <template>
        <v-container>
          <v-data-table
            :headers="headers"
            :items="dados"
            :loading="carregando"
            class="elevation-1"
            hide-default-footer
            disable-pagination
          >
            <template v-slot:[`item.Valor`]="{ item }">
              {{ "R$ " + formatNumber(item.Valor) }}
            </template>
          </v-data-table>
        </v-container>
      </template>
    </v-content>
  </v-app>
</template>

<script>
import Service from "@/components/api/Service";
import { formatNumber } from "cids-cgi/lib/util";
import { locale } from "../locale/locale";

export default {
  data: () => ({
    service: new Service(),
    hoje: new Date(),
    datas: [],
    meses: [
      "jan",
      "fev",
      "mar",
      "abr",
      "mai",
      "jun",
      "jul",
      "ago",
      "set",
      "out",
      "nov",
      "dez",
    ],
    dados: [],
    errorMessage: "",
    headers: [
      {
        text: locale[window.local].screen.comprasVarejo.table01.header01,
        value: "DataVenda",
      },
      {
        text: locale[window.local].screen.comprasVarejo.table01.header02,
        value: "NotaFiscal",
      },
      {
        text: locale[window.local].screen.comprasVarejo.table01.header03,
        value: "Valor",
        align: "end",
      },
    ],
    formatNumber: formatNumber,

    //Loadings
    loading: false,
    loadingPeriodos: false,
    carregando: false,
    filterPeriod: 0,
  }),
  mounted() {
    this.getMeses();
    this.filterPeriod = 0;
    if (this.datas.length > 0) {
      this.buscaVarejo(this.datas[0]);
    }
  },
  methods: {
    adicionaDias(dateObj, numDays) {
      dateObj.setDate(dateObj.getDate() + numDays);
      return dateObj;
    },

    async buscaVarejo(option) {
      try {
        this.loadingPeriodos = true;
        this.carregando = true;
        this.dados = [];
        var resposta = await this.service.getVarejo(option.mes, option.ano);
        if (resposta.status === 200) {
          if (resposta.data.Vendas.length > 0) {
            this.dados = resposta?.data?.Vendas ?? [];
          } else {
            this.setErrorMessage(
              locale[window.local].screen.comprasVarejo.error01Label
            );
          }
        } else {
          throw new Error();
        }
      } catch (e) {
        throw new Error(e);
      } finally {
        this.loadingPeriodos = false;
        this.carregando = false;
      }
    },

    getMeses() {
      //adiciona 12 dias a partir da data atual
      this.hoje = this.adicionaDias(new Date(), 12);

      for (var i = 1; i <= 6; i++) {
        //this.hoje.setMonth((this.hoje.getMonth()), -1);

        var stringDate =
          this.meses[this.hoje.getMonth()] + "/" + this.hoje.getFullYear();
        var thisMonth = this.hoje.getMonth() + 1;
        var thisYear = this.hoje.getFullYear();
        this.datas.push({
          descricao: stringDate,
          mes: thisMonth,
          ano: thisYear,
        });
        this.hoje.setMonth(this.hoje.getMonth(), -1);
      }
      return this.datas;
    },
  },
};
</script>

<style scoped>
.unread {
  background-color: lightgrey;
}

.unread_text {
  font-weight: bold;
}

.table-heigth {
  height: calc(100vh - 130px);
}
</style>
